type StorageKey = string;

export const setTokenItem = <T = string>(key: StorageKey, value: T) => {
  const storedValue = typeof value === 'string' ? value : JSON.stringify(value);
  localStorage.setItem(key, storedValue);
};

export const getTokenItem = <T = string>(key: StorageKey): T | undefined => {
  const value = localStorage.getItem(key);
  if (value === null) return undefined;
  try {
    return JSON.parse(value) as T;
  } catch {
    return value as unknown as T;
  }
};

export const clearTokenItem = (key: StorageKey) => {
  localStorage.removeItem(key);
};

export const TOKEN_KEY = {
  AUTH_TOKEN: 'AuthToken',
  REFRESH_TOKEN: 'refreshToken',
} as const;
